import React from 'react'
import { Trash2, GripVertical } from 'lucide-react'
import { Button } from '@w/components/ui/button'

interface FieldActionsProps {
  fieldId: string
  isRemovable: boolean
  onDelete: (fieldId: string) => void
}

/**
 * Action buttons that appear when field is selected
 * Shows delete button for removable fields
 *
 * Pattern from email builder's TuneMenu
 */
export default function FieldActions({ fieldId, isRemovable, onDelete }: FieldActionsProps) {
  if (!isRemovable) {
    return null
  }

  return (
    <div className="absolute -top-2 -right-2 z-10 flex items-center gap-1 bg-white border border-blue-500 rounded-md shadow-sm">
      {/* Drag handle (future) */}
      <div className="px-1.5 py-1 text-muted-foreground hover:text-foreground cursor-move opacity-50">
        <GripVertical className="w-4 h-4" />
      </div>

      {/* Delete button */}
      <Button
        variant="ghost"
        size="sm"
        onClick={(e) => {
          e.stopPropagation()
          if (confirm('Are you sure you want to remove this field?')) {
            onDelete(fieldId)
          }
        }}
        className="h-7 px-2 text-destructive hover:text-destructive hover:bg-destructive/10"
        title="Delete field"
      >
        <Trash2 className="w-4 h-4" />
      </Button>
    </div>
  )
}
